<template>
  <div>
    <div v-if="error" class="alert alert-primary bg-primary text-white border-0 show">
      {{$t(error)}}
    </div>

    <b-form novalidate @submit.prevent="submit">
      <div class="row">
        <div class="col-lg-6">
          <validated-form-input name="titleEst" label="Nimetus eesti keeles" placeholder="Sisesta nimetus eesti keeles"
                                v-model="classifier.titleEst"
                                validate="required" :validator="$validator"/>
        </div>

        <div class="col-lg-6">
          <b-form-group label="Nimetus inglise keeles" label-for="titleEng">
            <b-input-group>
              <b-form-input id="titleEng"
                            name="titleEng"
                            autocomplete="off"
                            type="text"
                            v-model="classifier.titleEng"
                            :aria-describedby="classifier.titleEng + 'Feedback'"
                            placeholder="Sisesta nimetus inglise keeles">
              </b-form-input>
            </b-input-group>
          </b-form-group>
        </div>

        <div class="col-lg-6">
          <validated-form-input name="value" label="Väärtus" v-model="classifier.value" :validator="$validator"
                                :disabled="true"/>
        </div>

        <div class="col-lg-6">
          <validated-form-input name="parent" label="Alamkategooria" v-model="classifier.parent" :validator="$validator"
                                :disabled="true"/>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <submit-button class="float-right" variant="primary" :disabled="submitting">Salvesta</submit-button>
        </div>
      </div>

    </b-form>

  </div>
</template>

<script>
  import ValidatedFormInput from '@/components/ValidatedFormInput'
  import ValidatedFormSelect from '@/components/ValidatedFormSelect'

  export default {
    props: ['classifier'],
    components: {ValidatedFormInput, ValidatedFormSelect},
    data() {
      return {
        submitting: false,
        error: null
      }
    },
    created() {
    },
    methods: {
      submit() {
        if (this.submitting) return;
        this.submitting = true

        this.$validator.validateAll().then(valid => {
          if (!valid) {
            this.submitting = false
            return
          }

          this.$gateway.patch(`/admin/classifiers`, this.classifier)
            .then(r => {
              this.$notifications.info(`Klassifikaator on muudetud`)
              this.submitting = false
              this.$emit('done')
            })
            .catch(r => {
              this.error = r.response.data.key
              this.submitting = false
            })
        })
      }
    }
  }
</script>
